/**
 * The kit's filter pill, shared by the agenda's tracks and the directory's certifications. Both
 * rows are one choice out of a list with an "everything" option, so both are pressed toggles
 * rather than links: the screen filters in place, and the chip says which way it is set.
 */
export function FilterChip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={`text-chip min-h-[30px] shrink-0 rounded-full px-4 font-semibold ${
        active ? 'bg-ink text-white' : 'border border-border-input bg-surface text-ink-2'
      }`}
    >
      {children}
    </button>
  );
}
